import { Component } from '@angular/core';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { WsConst } from '../../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-sessions',
  templateUrl: './sessions.component.html',
  styleUrls: ['./sessions.component.css'],
})
export class SessionsComponent extends SuperClass {
  dashboardData: any;

  chartOptions: any;
  totalSessions: any;
  sparkPieSessionsNewVsRet: any;
  averageSessionDur: any;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Usage Statistics' },
      {
        label: 'Sessions',
        routerLink: [{ outlets: { sub: [RouterConst.SESSIONS] } }],
      },
    ]);
  }

  setData(data) {
    this.dashboardData = data;
    this.chartsInit();
  }

  reloadData() {
    this.dashboardDataService.getDD('SessionsComponent');
  }

  getWebSocketIdentifier() {
    return WsConst.STATISTICS;
  }

  chartsInit() {
    this.chartOptions = {
      scaleFontColor: 'gray',

      legend: {
        labels: {
          fontColor: 'gray',
        },
      },

      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'gray',
              display: false,
            },
            stacked: true,
          },
        ],

        yAxes: [
          {
            scaleLabel: {
              display: true,
              // labelString: 'Load in %',
              fontColor: 'gray',
            },
            gridLines: {
              color: 'gray',
              display: true,
            },
            stacked: true,
          },
        ],
      },
    };
    this.totalSessions = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: 'New',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          order: 1,
          data: this.dashboardData.charts.totalSessionByTime.data1,
        },
        {
          label: 'Returning',
          backgroundColor: '#488BB4',
          hoverBackgroundColor: '#81D4FA',
          order: 2,
          data: this.dashboardData.charts.totalSessionByTime.data2,
        },
      ],
    };
    this.sparkPieSessionsNewVsRet = {
      labels: ['New for period', 'Returning for period'],
      datasets: [
        {
          data: this.dashboardData.charts.sparkPieSessionsNewVsRet.data,
          backgroundColor: ['#F6BD60', '#488BB4'],
          hoverBackgroundColor: ['#FFE082', '#81D4FA'],
        },
      ],
    };
    this.averageSessionDur = {
      labels: [
        '0-6am',
        '6am',
        '7am',
        '8am',
        '9am',
        '10am',
        '11am',
        'Noon',
        '1pm',
        '2pm',
        '3pm',
        '4pm',
        '5pm',
        '6pm',
        '7pm',
        '8pm',
        '9pm',
        '> 10pm',
      ],
      datasets: [
        {
          label: 'Average Duration',
          backgroundColor: '#F6BD60',
          hoverBackgroundColor: '#FFE082',
          data: this.dashboardData.charts.avgSessionsDurationByTime.data1,
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/usage_statistics/sessions/sessions.component.ts